// extracted by mini-css-extract-plugin
export default {"form":"add-sender-info-form_form__mVYLi","grid":"add-sender-info-form_grid__gm3Qh","field":"add-sender-info-form_field__VYRDE","title":"add-sender-info-form_title__17S0x"};